import React, { FC } from 'react';

import { COMPATIBILITY__ATTACHMENT_PREVIEW } from '../../../../constants/nativeCompatibility';
import useNativeCompatibility from '../../../../hooks/native/useNativeCompatibility';
import useIsMobile from '../../../../hooks/useIsMobile';
import {
  AttachmentAction,
  AttachmentMode,
} from '../../../../models/attachment';
import Ribbon from '../../../Common/Ribbon';
import ButtonAttachmentAction from '../ButtonAttachmentAction';

import * as Styled from './styled';

export type Props = {
  actionDownload: AttachmentAction;
  actionPreview: AttachmentAction;
  canDownloadFile: boolean;
  className?: string;
  mode: AttachmentMode;
};

const ICON_SIZE = 20;

/**
 * A attachment ribbon component used to show download button
 *
 * @param props                 Props passed to the component
 * @param props.actionDownload  Attachment action download props
 * @param props.actionPreview   Attachment action preview props
 * @param props.canDownloadFile Whether download button should be shown
 * @param props.className       styled-components generated class name, needed for styling
 * @param props.mode            In which mode to render the component
 * @returns                     The component itself
 */
const AttachmentRibbon: FC<Props> = ({
  actionDownload,
  actionPreview,
  canDownloadFile,
  className,
  mode,
}) => {
  const isMobile = useIsMobile();
  /**
   * @todo Remove this after oldest used app version is >= 1.8
   * Check in App Conect and Play Console statistics.
   */
  const isCompatibleAttachmentPreview = useNativeCompatibility(
    COMPATIBILITY__ATTACHMENT_PREVIEW,
  );

  if (isMobile || mode !== 'feed' || canDownloadFile === false) {
    return null;
  }

  return (
    <Styled.Wrapper className={className}>
      <Ribbon>
        {isCompatibleAttachmentPreview && (
          <ButtonAttachmentAction
            actionType="preview"
            iconSize={ICON_SIZE}
            isInProgress={actionPreview.isInProgress}
            link={actionPreview.link}
            linkRef={actionPreview.linkRef}
            requestButtonClick={actionPreview.requestButtonClick}
          />
        )}
        <ButtonAttachmentAction
          actionType="download"
          iconSize={ICON_SIZE}
          isInProgress={actionDownload.isInProgress}
          link={actionDownload.link}
          linkRef={actionDownload.linkRef}
          requestButtonClick={actionDownload.requestButtonClick}
        />
      </Ribbon>
    </Styled.Wrapper>
  );
};

export default AttachmentRibbon;
